import { useCallback, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { SideNav } from './SideNav'
import { TopBar } from './TopBar'

const NAV_KEY = 'bb.nav.open'

/* Layout shell for every /app route: fixed TopBar, fixed SideNav rail, and the
   page body offset to clear both.

   The chrome is BatchBooks; most page bodies below it are still the LedgerLift
   styling from app.css, which is why <main> keeps app.css's `.page` padding.
   The rail's collapsed state is remembered so it survives navigation and
   reloads. */
export function AppShell() {
  const [navOpen, setNavOpen] = useState(() => localStorage.getItem(NAV_KEY) === 'open')

  const toggleNav = useCallback(() => {
    setNavOpen((open) => {
      const next = !open
      localStorage.setItem(NAV_KEY, next ? 'open' : 'closed')
      return next
    })
  }, [])

  return (
    <div className="bb-appwrap">
      <TopBar />
      <SideNav open={navOpen} onToggle={toggleNav} />

      <main className={navOpen ? 'view page bb-app-main bb-app-main-wide' : 'view page bb-app-main'}>
        <Outlet />
      </main>

      <footer className={navOpen ? 'bb bb-appfoot bb-appfoot-wide' : 'bb bb-appfoot'}>
        <div className="bb-appfoot-in">
          <span>© {new Date().getFullYear()} BatchBooks Professional. All rights reserved.</span>
          {/* Support, Terms and Privacy appear in the prototypes but have no
              pages yet, so only destinations that exist are linked. */}
          <nav className="bb-appfoot-links">
            <Link to="/#faq">Help Centre</Link>
            <Link to="/#pricing">Plans</Link>
          </nav>
        </div>
      </footer>
    </div>
  )
}
